import { LockOutlined, UserOutlined } from '@ant-design/icons'
import { Button, Form, Input, message } from 'antd'
import { useForm } from 'antd/es/form/Form'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { ReactComponent as ProfileIcon } from '../../assets/Icons_Profile Fill.svg'
import { DASHBOARD } from '../../constants/pathConstant'
import { displayMessage } from '../../helpers/Message'
import {
  errorAuth,
  forgotPassword,
  login,
  selectErrorInAuth,
  selectSuccessInAuth,
  successAuth,
} from '../../state/auth/authReducer'
import { forgotPasswordDataType, loginDataType } from '../../state/auth/types'
import {
  LoginFormAvatar,
  LoginFormContainer,
  LoginFormControls,
  LoginFormTitle,
  LoginScreenContainer,
} from './LoginScreenStyle'

function LoginScreen() {
  const [messageApi, contextHolder] = message.useMessage()
  const [loginForm] = useForm()
  const [forgetPasswordForm] = useForm()
  const [loginScreenState, setLoginScreenState] = useState(true)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const onFinishLoginForm = (values: loginDataType) => {
    dispatch(login(values))
  }
  const onFinishForgotPasswordForm = (values: forgotPasswordDataType) => {
    dispatch(dispatch(forgotPassword(values)))
  }

  const formSubmit = () => {
    if (loginScreenState) {
      loginForm.submit()
    } else {
      forgetPasswordForm.submit()
    }
  }

  const authError = useSelector(selectErrorInAuth)
  const authSuccess = useSelector(selectSuccessInAuth)

  useEffect(() => {
    if (authError) {
      displayMessage(authError, 'error', messageApi)
      dispatch(errorAuth(null))
    }
  }, [authError])

  useEffect(() => {
    if (authSuccess) {
      if (loginScreenState) navigate(DASHBOARD)
      else {
        displayMessage(authSuccess, 'success', messageApi)
        forgetPasswordForm.resetFields()
      }
      dispatch(successAuth(null))
    }
  }, [authSuccess])

  const onStateChange = () => {
    setLoginScreenState((prev) => !prev)
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      formSubmit()
    }
  }

  return (
    <LoginScreenContainer>
      {contextHolder}
      <LoginFormContainer>
        <LoginFormAvatar>
          <ProfileIcon />
        </LoginFormAvatar>
        <LoginFormTitle>
          {loginScreenState ? 'Vitalleads Login' : 'Forget Password'}
        </LoginFormTitle>
        {loginScreenState && (
          <Form
            name='normal_login'
            form={loginForm}
            initialValues={{ remember: true }}
            onFinish={onFinishLoginForm}
          >
            <Form.Item
              name='username'
              rules={[
                { required: true, message: 'Please input your username!' },
              ]}
            >
              <Input
                style={{ width: '250px' }}
                prefix={<UserOutlined />}
                placeholder='Username'
              />
            </Form.Item>
            <Form.Item
              name='password'
              rules={[
                { required: true, message: 'Please input your Password!' },
              ]}
            >
              <Input
                style={{ width: '250px' }}
                prefix={<LockOutlined />}
                type='password'
                placeholder='Password'
                onKeyDown={handleKeyDown}
              />
            </Form.Item>
          </Form>
        )}
        {!loginScreenState && (
          <Form
            name='normal_login'
            form={forgetPasswordForm}
            initialValues={{ remember: true }}
            onFinish={onFinishForgotPasswordForm}
          >
            <Form.Item
              name='emailId'
              rules={[{ required: true, message: 'Please input your email!' }]}
            >
              <Input
                onKeyDown={handleKeyDown}
                style={{ width: '250px' }}
                prefix={<UserOutlined />}
                placeholder='Email'
              />
            </Form.Item>
          </Form>
        )}
        <LoginFormControls>
          <Button type='primary' onClick={formSubmit}>
            {loginScreenState && 'Log in'}
            {!loginScreenState && 'Submit'}
          </Button>
          <Button
            className='loginTextButton'
            onClick={onStateChange}
            type='link'
          >
            {loginScreenState && 'Forgot password'}
            {!loginScreenState && 'Log In'}
          </Button>
        </LoginFormControls>
      </LoginFormContainer>
    </LoginScreenContainer>
  )
}

export default LoginScreen
